import { SETTINGS_KEY } from '@obraplan/core/application/ports/repositories';
import type { ObraPlanDb } from './db';

/**
 * As sessões que saíram sem sinal e ainda não foram encerradas no servidor (Fase 43, RN-616).
 *
 * Quem sai sem sinal tem o token apagado do tablet na hora, como sempre. Mas a sessão continuaria
 * válida no servidor por até 30 dias, alcançável por quem tivesse uma cópia do token. O token fica
 * aqui só até o sinal voltar e o servidor encerrar a sessão dele — o mesmo lugar onde ele já
 * morava enquanto valia (\`appSettings\`).
 */
export class DexiePendingSignOuts {
  constructor(private readonly db: ObraPlanDb) {}

  async list(): Promise<string[]> {
    const linha = await this.db.appSettings.get(SETTINGS_KEY.PENDING_SIGN_OUTS);
    return Array.isArray(linha?.value) ? (linha.value as string[]) : [];
  }

  async add(token: string, nowIso: string): Promise<void> {
    const atuais = await this.list();
    if (atuais.includes(token)) return;
    await this.gravar([...atuais, token], nowIso);
  }

  async remove(token: string, nowIso: string): Promise<void> {
    await this.gravar(
      (await this.list()).filter((guardado) => guardado !== token),
      nowIso,
    );
  }

  private async gravar(tokens: readonly string[], nowIso: string): Promise<void> {
    if (tokens.length === 0) {
      await this.db.appSettings.delete(SETTINGS_KEY.PENDING_SIGN_OUTS);
      return;
    }
    await this.db.appSettings.put({
      key: SETTINGS_KEY.PENDING_SIGN_OUTS,
      value: tokens,
      updatedAt: nowIso,
    });
  }
}
